import React, { Component } from 'react';
import AssinaturaRodape from '@componentes/AssinaturaRodape';
import logoMV from '../../../../assets/logos/logo-mv.svg';

class TermoConsolidadoTemplate extends Component {
  render () {
    return (
      <div style={{padding: '60px', fontFamily: 'sans-serif'}}>
        <div style={{display: 'inline-block', width: '100%', marginBottom: '10px'}}>
          <div style={{display: 'inline-block', position: 'absolute'}}>
            <img alt='logo' style={{maxHeight: '90px'}}
              src={
                this.props.termoNConfConsolidado.dadosGeraisHospital &&
                this.props.termoNConfConsolidado.dadosGeraisHospital.logoBase64
                  ? `data:image/png;base64,${this.props.termoNConfConsolidado.dadosGeraisHospital.logoBase64}`
                  : logoMV
              }
            />
          </div>
          <div style={{width: '100%', display: 'inline-block', textAlign: 'center', fontSize: '26px', fontWeight: '600', marginBottom: '12px'}}>
            <p style={{ margin: '0'}}>Termo de anuência</p>
            <p style={{ margin: '0'}}>Laboratório Anatomia Patológica</p>
          </div>
        </div>
        <div>
          <table style={{ width: '100%'}}>
            <tbody>
              <tr>
                <td colSpan='2' style={{border: '1px solid', height: '65px', fontSize: '18px', verticalAlign: 'top'}}>
                  1 - Paciente
                  <span style={{display: 'block', marginTop: '10px', marginLeft: '5px'}}>
                    {this.props.termoNConfConsolidado.paciente}
                  </span>
                </td>
                <td rowSpan='2'style={{border: '1px solid', fontSize:'18px', textAlign:'center'}}>
                  Cole aqui a etiqueta do paciente
                </td>
              </tr>
              <tr>
                <td style={{border: '1px solid', height: '65px', fontSize: '18px', verticalAlign: 'top'}}>
                  2 - Leito
                  <span style={{display: 'block', marginTop: '10px', marginLeft: '5px'}}>
                    {this.props.termoNConfConsolidado.leito}
                  </span>
                </td>
                <td style={{border: '1px solid', height: '65px', fontSize: '18px', verticalAlign: 'top'}}>
                  3 - Registro
                  <span style={{display: 'block', marginTop: '10px', marginLeft: '5px'}}>
                    {this.props.termoNConfConsolidado.registro}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <p style={{textAlign: 'center', fontSize: '18px', fontWeight: 600, marginTop: '10px'}}>Recebimento de amostras com restrições:</p>
          {this.props.termoNConfConsolidado.listaNaoConformidades.map(x =>
          (
            <div>
              <p style={{fontWeight: 600}}>{x.nConf}</p>
              <ul>
                <li>{x.observacao}</li>
              </ul>
            </div>
          ))}
        </div>
        <div style={{bottom: 0, position: 'absolute', padding: '0 30px 0 20px'}}>
          <AssinaturaRodape
            localAndData={this.props.termoNConfConsolidado.dadosGeraisHospital.localAndData}
            rg={this.props.termoNConfConsolidado.rg}
            texto={'Estou ciente de que os resultados finais podem apresentar distorções e que na impossibilidade de realização dos exames será solicitado nova coleta. Desejo mesmo assim proceder à execução do(s) exame(s)'}
          />
        </div>
      </div>
    );
  }
}

export default TermoConsolidadoTemplate;



// WEBPACK FOOTER //
// ./src/app/common/inconformidade/modelos/termo.consolidado.template.js